import React from 'react';

import withModalLayoutContainer from '../../common/Modal/ModalLayoutContainer';

const RebateDetailsModal = withModalLayoutContainer((props) => {
    return (
        <div className="rebate-details">
            <div dangerouslySetInnerHTML={{__html: props.content}}></div>
        </div>
    )
});

export { RebateDetailsModal };
